import { Link } from "react-router-dom";

const data = [
    {
        title: 'Responsive Web Design',
        provider: 'freeCodeCamp',
        providerImg: 'freecodecamp.png',
        issued: 'February 26, 2025',
        url: 'https://www.freecodecamp.org/certification/fccf42f9ace-87c9-46c6-a40c-0180854fe0ad/responsive-web-design'
    },
    {
        title: 'JavaScript Algorithms and Data Structures',
        provider: 'freeCodeCamp',
        providerImg: 'freecodecamp.png',
        issued: 'February 27, 2025',
        url: 'https://www.freecodecamp.org/certification/fccf42f9ace-87c9-46c6-a40c-0180854fe0ad/javascript-algorithms-and-data-structures-v8'
    },
];
function Certifications() {
    return (
        <div className="certifications-section">
            <div className="certifications-grid">
                {
                    data.map((entry, index) => {
                        return (
                            <div className="cert-card bg-white dark:bg-khi-700" key={index}>
                                <div className="cert-card-content">
                                    <div className="cert-icon">
                                        <img src={`img/cert/${entry.providerImg}`} alt={entry.provider} />
                                    </div>
                                    <div>
                                        <div className="cert-title text-white">{entry.title}</div>
                                        <div className="cert-provider text-khi-50">{entry.provider}</div>
                                        <div className="cert-issue-date text-khi-50">{entry.issued}</div>
                                        <div className="view-button-container">
                                            <Link to={entry.url} target="_blank">View</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default Certifications